<div id="vtz-main-wrapper" class="vtz-main-wrapper">
  <div id="vtz-main-container" class="vtz-main-container vtz-main-container--ballot vtz-main-container--tall">
    <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main id="vtz-success-code-wrapper" class="vtz-success-code__wrapper">
      <h2 id="vtz-success-code-text" class="vtz-h1 vtz-text--wide vtz-text--center" i18n>Voluntary Survey</h2><br>
      @if (surveyLink.length > 0) {
        <p class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
          You are invited to participate in a 3-5 minute online survey (through an external website) about your online voting experience today. Your responses will assist {{organization}} with planning future elections. Participation is voluntary and all responses are confidential.
      </p>
      }
      <div class="vtz-actions button-group">
        <button id="exit-button" class="button-secondary" i18n="Button" (click)="exit()">Exit</button>
        @if (surveyLink.length > 0) {
          <a href="{{surveyLink}}" target="_blank">
            <button id="start-survey-button" class="button-primary" i18n="Button">Start Survey</button>
          </a>
        }
      </div>
    </main>
  </div>
</div>